import React from "react";
export default function Icon(props) {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.60005 5.29998H10.4001M5.60005 7.69998H10.4001M5.60005 10.1H8.00005M4.39987 2.09998H11.6C12.4837 2.09998 13.2 2.81634 13.2 3.70001L13.1998 13.3C13.1998 14.1837 12.4835 14.9 11.5998 14.9L4.3998 14.8999C3.51614 14.8999 2.7998 14.1836 2.7998 13.2999L2.79987 3.69997C2.79987 2.81632 3.51621 2.09998 4.39987 2.09998Z"
        stroke="#13816F"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
